import { ArrowRightIcon } from '@phosphor-icons/react';
import ModalCloseButton from '../generic/ModalCloseButton';
import { Button } from '../ui/button';
import { useEffect } from 'react';

const PurchasePackModal = ({
  packTitle,
  paymentItemId,
  couponCode,
  exam,
  onClose,
  isResources = false,
  showClose = true,
  showSidebar = false,
}) => {
  useEffect(() => {
    let selectedPack = window.localStorage.getItem('selectedPack');
    const user = JSON.parse(window.localStorage.getItem('userProfile'));
    let paymentUrl = '#';
    if (selectedPack) {
      selectedPack = JSON.parse(selectedPack);
      paymentUrl = `https://pay.mathongo.com/?item_id=${selectedPack?.paymentItemId}&coupon=${selectedPack?.couponCode}&utm_source=quizrr&utm_medium=web_push&utm_campaign=quizrr_freemium`;
    }
    window.webengage.track('modal_viewed', {
      'User Id': user?.email,
      'Pack Name': packTitle,
      'Modal Name': 'purchase_pack_modal',
      Trigger: isResources ? 'resources' : 'test',
      ...(paymentUrl !== '#' ? { 'Payment Url': paymentUrl } : {}),
    });
  }, []);
  return (
    <div
      className={`fixed inset-0 ${showSidebar && 'lg:left-[100px]'} z-40 flex items-center justify-center p-4`}
      style={{
        background: 'rgba(16, 24, 40, 0.70)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div className="relative bg-[var(--q3-surface-default)] rounded-lg p-6 w-fit">
        {showClose && <ModalCloseButton onClick={onClose} />}

        <div className="flex flex-col gap-3 items-center">
          <img src={exam[0]?.icon} alt={exam[0]?.title} className="w-8 h-8" />
          <p className="text-[var(--q3-accent-normal)] font-bold whitespace-nowrap">{packTitle.split('(')[0]}</p>
          <p className="text-[var(--q3-neutral-default)] text-[28px] font-bold text-center">
            Unlock the test series to
            <br /> {isResources ? 'access the resources' : 'attempt the test'}
          </p>
          <Button
            // variant="outline"
            className="group flex flex-row mt-2 shadow-none rounded-full w-full border-none !bg-[var(--q3-danger-normal)] hover:scale-100"
            onClick={() => {
              window.open(
                `https://pay.mathongo.com?item_id=${paymentItemId}&coupon=${couponCode}&utm_source=quizrr&utm_medium=non_purchased_test_details&utm_campaign=quizrr_freemium`,
                '_blank',
              );
            }}
          >
            Purchase Test Series
            <ArrowRightIcon className="group-hover:translate-x-1 transition-all duration-300" />
          </Button>
          <p className="text-[var(--q3-neutral-light)] text-center">
            You are about to unlock the <br />
            <strong>MOST RELEVANT</strong> test series for {exam.title}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PurchasePackModal;
